export default __webpack_public_path__ + "static-bigflip/media/icon-step-2.f3c20e39.png";